import { IProductCategory, PRODUCT_CATEGORIES } from '@/api/products/queries/get-product-query'
import { USER_FACING_PRODUCT_CATEGORIES } from '@/setup/routing/routing'

export const convertProductCategoryToUserFacingProductCategory = (productCategory: IProductCategory) => {
    switch (productCategory) {
        case PRODUCT_CATEGORIES.APP:
            return USER_FACING_PRODUCT_CATEGORIES.MOBILE_APP
        case PRODUCT_CATEGORIES.E_COMMERCE:
            return USER_FACING_PRODUCT_CATEGORIES.E_COMMERCE
        case PRODUCT_CATEGORIES.OTHER:
            return USER_FACING_PRODUCT_CATEGORIES.WEBSITE
        default: {
            return USER_FACING_PRODUCT_CATEGORIES.WEBSITE
        }
    }
}
